<!--
 * @Author: chengleilei
 * @Date: 2025-11-18 11:24:32
 * @Description: 门店照片tab
-->
<template>
    <div class="store-photo">
        <Card bordered dis-hover>
            <span
                v-viewer="{ movable: false }"
                v-for="(item, index) in fileList"
                :key="index"
                class="v-viewer-container"
            >
                <img :src="item.url" class="v-viewer-img img-box" />
            </span>
            <div v-if="fileList.length < 1" class="no-data">暂无门店照片</div>
        </Card>
    </div>
</template>

<script>
export default {
    props: {
        fileList: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
};
</script>

<style lang="less" scoped>
.store-photo {
    .img-box {
        width: 300px;
        height: 300px;
    }
    .no-data {
        line-height: 170px;
        width: 100%;
        text-align: center;
    }
}
</style>
